export const APP_STATES = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}

// For TrainingWithAI - Start

export const ALL_OPTION_VALUE = ''
export const VISITOR_FEEDBACK_OPTIONS = [
  { label: 'Helpful', value: 'helpful' },
  { label: 'Not Helpful', value: 'not_helpful' }
]
export const VISITOR_FEEDBACK_FILTER_OPTIONS = [{ label: 'All', value: ALL_OPTION_VALUE }, ...VISITOR_FEEDBACK_OPTIONS]

export const BOT_RESPONSE_FEEDBACK_OPTIONS = [
  { label: 'Answered', value: 'answered' },
  { label: 'Unanswered', value: 'unanswered' }
]
export const BOT_RESPONSE_FILTER_OPTIONS = [{ label: 'All', value: ALL_OPTION_VALUE }, ...BOT_RESPONSE_FEEDBACK_OPTIONS]

export const ADMIN_FEEDBACK_VALUE = {
  RELEVANT: 'relevant',
  NOT_RELEVANT: 'not_relevant',
  NOT_RELEVANT_NO_CONTENT: 'not_relevant_source_not_exists'
}

export const ADMIN_FEEDBACK_OPTIONS = [
  { label: 'Relevant', value: ADMIN_FEEDBACK_VALUE.RELEVANT },
  { label: 'Not relevant, relevant content available', value: ADMIN_FEEDBACK_VALUE.NOT_RELEVANT },
  { label: 'Not relevant, content required', value: ADMIN_FEEDBACK_VALUE.NOT_RELEVANT_NO_CONTENT }
]

export const ADMIN_FEEDBACK_FILTER_OPTIONS = [{ label: 'All', value: ALL_OPTION_VALUE }, ...ADMIN_FEEDBACK_OPTIONS]

export const ADMIN_FEEDBACK_DROPDOWN_OPTIONS = ADMIN_FEEDBACK_OPTIONS

export const NO_RESULTS_MSG = `No results found for given query`

export const FALLBACK_TEXT = '-'

// For TrainingWithAI - End

// For theme - Start

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark'
}

export const THEME_COLORS = {
  [THEME.DARK]: '#000000',
  [THEME.LIGHT]: '#FFFFFF'
}

export const DEFAULT_TEXT_COLOR_THEME = THEME.LIGHT
export const TEXT_COLOR_OPTIONS = [
  {
    label: 'Dark',
    value: THEME.DARK
  },
  {
    label: 'Light',
    value: DEFAULT_TEXT_COLOR_THEME
  }
]
export const DEFAULT_BRAND_COLOR = '#4C29E7'
export const DEFAULT_LABEL_BG_COLOR = '#FFFFFF'
export const DEFAULT_LABEL_TEXT_COLOR = THEME.DARK

// For theme - End

// For badge position - Start

export const BADGE_POSITION_VALUE = {
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM_LEFT: 'bottomLeft',
  CENTER_RIGHT: 'centerRight',
  CENTER_LEFT: 'centerLeft'
}
export const DEFAULT_BADGE_POSITION = BADGE_POSITION_VALUE.BOTTOM_RIGHT

export const BADGE_POSITION_OPTIONS = [
  {
    label: 'Bottom Right',
    value: BADGE_POSITION_VALUE.BOTTOM_RIGHT
  },
  {
    label: 'Bottom Left',
    value: BADGE_POSITION_VALUE.BOTTOM_LEFT
  },
  {
    label: 'Center Right',
    value: BADGE_POSITION_VALUE.CENTER_RIGHT
  },
  {
    label: 'Center Left',
    value: BADGE_POSITION_VALUE.CENTER_LEFT
  }
]

// For badge position - End

// For ML search - Start

export const EMPTY_RESPONSE_MESSAGE = `I apologize, but I can only answer questions related to {companyName}. Please provide more information or ask a specific question.`
export const EMPTY_RESPONSE_TOOLTIP = `The response shown here may differ from the custom response you have set.`

// For ML search - End

// For Bot Message - Start

export const DEFAULT_WHITELISTED_TAGS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'div',
  'figcaption',
  'figure',
  'hr',
  'li',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'b',
  'br',
  'em',
  'small',
  'span',
  'strong',
  'img'
]

// For Bot Message - End

// For HTML Tag Validation - Start

export const ALL_HTML_TAG_REGEX = /<[^\s]([^>]+)>/g // matches everything enclosed in <> and there should not be immediate whitespaces after <

// For HTML Tag Validation - End
